export default "__VITE_ASSET__D14HEYX9__"